module.exports = require("./ru-MD.d.ts");